import BaseFooter from '@bnnvara/footers';
import Link from 'next/link';
import React from 'react';

const Footer = () => <BaseFooter LinkComponent={Link} />;

export default Footer;
